import type { IconData } from '@stacksjs/iconify-core'

export const devicesMouse: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 0a6 6 0 0 0-6 6v4a6 6 0 0 0 12 0V6a6 6 0 0 0-6-6m0 6.25a1.25 1.25 0 1 0 0-2.5a1.25 1.25 0 0 0 0 2.5\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default devicesMouse
